// USD pricing derived from Stickerbeat_Calculator_FIXED_Oct5-50Minimum.xlsx - Calculator.csv.
// Columns: quantities 50, 100, 200, 300, 500, 800, 1000+.
// Each rate is the maximum CSV total / quantity in its band, rounded UP to 1e-8 USD.
// Size rows run from 1 x 1 to 20 x 20 in 0.5-inch steps.
// Larger sizes in the source CSV are estimates. No further discounts above 1000.
(function () {
    const quantityBreaks = [50, 100, 200, 300, 500, 800, 1000];
    const unitRates = [
        [69807693, 56304000, 53000000, 47501640, 44100991, 43659601, 43218000], // 1 x 1
        [78687500, 66424529, 64622223, 53811502, 49160920, 48668974, 48177000], // 1.5 x 1.5
        [103000000, 91803922, 89000000, 74401316, 64100971, 63459590, 62818000], // 2 x 2
        [107648149, 100673268, 91762377, 77811502, 66930967, 66261295, 65591000], // 2.5 x 2.5
        [131207548, 116304762, 109201971, 95000000, 82200796, 81378581, 80556000], // 3 x 3
        [149486487, 131174758, 125352113, 111791531, 101650944, 100634117, 99617000], // 3.5 x 3.5
        [165509804, 144203884, 139601991, 126701640, 118900991, 117711611, 116522000], // 4 x 4
        [184849057, 159944445, 156262377, 144641510, 143260957, 141828010, 140395000], // 4.5 x 4.5
        [217000000, 186000000, 185201971, 174201321, 173900991, 172161604, 170422000], // 5 x 5
        [267327869, 230714286, 227671937, 210851486, 204830910, 202782297, 200733000], // 5.5 x 5.5
        [291000000, 251703704, 247601991, 228101308, 219400794, 217206602, 215012000], // 6 x 6
        [316486487, 274384616, 269042254, 246741434, 235040936, 232690211, 230339000], // 6.5 x 6.5
        [340307693, 295403847, 289102326, 264101539, 249700918, 247203593, 244706000], // 7 x 7
        [390127273, 339864078, 331302440, 300571429, 280620953, 277814408, 275008000], // 7.5 x 7.5
        [406368422, 360403847, 349801981, 318351516, 300000000, 297000000, 294000000], // 8 x 8
        [424513158, 382924529, 370052381, 337801325, 321460938, 318246003, 315031000], // 8.5 x 8.5
        [424769231, 404054055, 385682243, 355188119, 346524951, 343059333, 339594000], // 9 x 9
        [473269231, 450194445, 429727273, 395751634, 386096900, 382235661, 378374000], // 9.5 x 9.5
        [524392406, 498824075, 476152074, 438504984, 427808967, 423530511, 419252000], // 10 x 10
        [578148149, 549954546, 524957346, 483451411, 471658960, 466941996, 462225000], // 10.5 x 10.5
        [634513158, 603584159, 576142223, 530588236, 517648916, 512472119, 507295000], // 11 x 11
        [693509804, 659694445, 629712265, 579921569, 565776938, 560118824, 554460000], // 11.5 x 11.5
        [755127273, 718314286, 685657277, 631444806, 616042969, 609882152, 603721000], // 12 x 12
        [819368422, 779414415, 743987125, 685161491, 668450868, 661766090, 655081000], // 12.5 x 12.5
        [886228071, 843013246, 804697248, 741071429, 722994855, 715764638, 708534000], // 13 x 13
        [955707693, 909114286, 867787129, 799171618, 779680934, 771883808, 764086000], // 13.5 x 13.5
        [1027807693, 977694445, 933257426, 859468153, 838502995, 830117576, 821732000], // 14 x 14
        [1102529412, 1048784314, 1001107318, 921954839, 899466927, 890471924, 881477000], // 14.5 x 14.5
        [1179867925, 1122354546, 1071336634, 986631579, 962566930, 952940904, 943315000], // 15 x 15
        [1259849057, 1198424529, 1143952381, 1053504984, 1027808967, 1017530511, 1007252000], // 15.5 x 15.5
        [1342432099, 1276993289, 1218947369, 1122568182, 1095188977, 1084236715, 1073284000], // 16 x 16
        [1427648149, 1358054055, 1296322275, 1193824841, 1164706931, 1153059554, 1141412000], // 16.5 x 16.5
        [1515486487, 1441603961, 1376077295, 1267274835, 1236364892, 1224000000, 1211637000], // 17 x 17
        [1605928572, 1527654206, 1458212265, 1342914827, 1310160920, 1297058969, 1283957000], // 17.5 x 17.5
        [1699000000, 1616194445, 1542727273, 1420751498, 1386096900, 1372235661, 1358374000], // 18 x 18
        [1794706897, 1707224300, 1629622120, 1500778146, 1464172963, 1449530865, 1434889000], // 18.5 x 18.5
        [1893020000, 1800754902, 1718902326, 1582994653, 1544386916, 1528942721, 1513498000], // 19 x 19
        [1993989899, 1896784314, 1810562212, 1667408228, 1626738889, 1610471166, 1594203000], // 19.5 x 19.5
        [2097549020, 1995294118, 1904601991, 1754011397, 1711230920, 1694118307, 1677005000], // 20 x 20
    ];

    function calculate(width, height, quantity) {
        if (!Number.isFinite(width) || !Number.isFinite(height) ||
            width < 1 || height < 1 || width > 20 || height > 20 ||
            !Number.isSafeInteger(quantity) || quantity < 50) {
            throw new RangeError('Transfer stickers require dimensions from 1 to 20 inches and a whole quantity of at least 50.');
        }

        let tier = 0;
        for (let i = 1; i < quantityBreaks.length; i++) {
            if (quantity >= quantityBreaks[i]) tier = i;
        }

        const area = width * height;
        let upper = 0;
        while (upper < unitRates.length - 1 && (1 + upper * 0.5) ** 2 < area) upper++;

        let rate = unitRates[upper][tier];
        if (upper > 0) {
            const lowerArea = (1 + (upper - 1) * 0.5) ** 2;
            const upperArea = (1 + upper * 0.5) ** 2;
            const fraction = (area - lowerArea) / (upperArea - lowerArea);
            rate = Math.ceil(unitRates[upper - 1][tier] +
                fraction * (unitRates[upper][tier] - unitRates[upper - 1][tier]));
        }

        // Integer rate units -> cents, always rounded up to preserve the CSV floor.
        return Math.ceil(rate * quantity / 1000000) / 100;
    }

    window.TransferStickersCalculator = { calculate };
})();
